function spbc_admin_set_cookie(name, data, expires){
	var date = new Date(new Date().getTime() + 1000 * expires );
	document.cookie = name + '=' + data + '; path=/; expires=' + date.toUTCString();
}

function spbcGetGoogleQrCode() {
	var data = {};
	var res = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_get_google_qr_code';

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			res = result;
		},
	});
	return res;
}

function spbcCheckGoogleCode() {
	var data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_check_google_code';
	data.code = jQuery('#spbct-google-qr-code input').val();

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				jQuery('#spbct-google-qr-code').dialog( "close" );
				document.location.reload();
			} else {
				alert(result.data);
			}
		},
	});
}

function spbcDisableG2fa( element ) {
	var data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_disable_google_2fa';
    data.user_id = jQuery(element).data('user-id');

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				document.location.reload();
			} else {
				alert(result.data);
			}
		},
	});
}

jQuery(document).ready(function(){
	
	// Auto update banner close handler 
	jQuery('.spbc_update_notice').on('click', 'button', function(){
		spbc_admin_set_cookie('spbc_update_banner_closed', 1, 86400 * 30);
	});

	// Enable G2FA from user profile page
	jQuery(document).on('click', '#spbc-g2fa-enable', function(e){

		e.preventDefault();
		var spbcGoogleQrCode = spbcGetGoogleQrCode();

		if( spbcGoogleQrCode.success ) {
			var qr_code_div = jQuery('#spbct-google-qr-code-img');
			qr_code_div.html(spbcGoogleQrCode.data.img + '<p>' + spbcGoogleQrCode.data.code + '</p>');
			jQuery('#spbct-google-qr-code input').val('');
			jQuery('#spbct-google-qr-code').dialog({
				modal: true,
				title: 'Google authenticator activation',
				buttons: {
					Cancel: function() {
						jQuery( this ).dialog( "close" );
					},
					Ok: function() {
						spbcCheckGoogleCode();
					}
				},
				draggable: false,
				resizable: false,
			});
		} else {
			alert(spbcGetGoogleQrCode.data);
		}

	});

	// Disable G2FA from user profile page
	jQuery(document).on('click', '#spbc-g2fa-disable', function(e){

		e.preventDefault();
		if( confirm( 'Are you sure?' ) ) {
			spbcDisableG2fa( this );
		}

	});
	
});